
import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio";
import { forwardRef } from "react";

// Check if we're in a browser environment
const isBrowser = typeof window !== "undefined";

// Create a component that only renders the actual AspectRatio in browser environments
const AspectRatio = forwardRef<
  React.ElementRef<typeof AspectRatioPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AspectRatioPrimitive.Root>
>(({ ratio = 16 / 9, className, style, children, ...props }, ref) => {
  // For SSR, render a simple div with appropriate styling
  if (!isBrowser) {
    const paddingBottom = `${(1 / ratio) * 100}%`;
    return (
      <div 
        ref={ref as any} 
        style={{ 
          position: "relative", 
          width: "100%", 
          paddingBottom, 
          ...style 
        }} 
        className={className}
        {...props}
      >
        <div style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }}>
          {children}
        </div>
      </div>
    );
  }
  
  // For browser environments, use the actual AspectRatio component
  return (
    <AspectRatioPrimitive.Root
      ref={ref}
      ratio={ratio}
      className={className}
      style={style}
      {...props}
    >
      {children}
    </AspectRatioPrimitive.Root>
  );
});

AspectRatio.displayName = "AspectRatio";

export { AspectRatio };
